export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_CATALOGS':
      return {
        ...state,
        catalogs: action.payload.data,
      }
    default:
      return state
  }
}
